import React, { useContext, useState, useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import { UserContext } from "../Context/UserContext";
import { useParams, useNavigate } from "react-router-dom";
import "../styleSheets/friendProfile.css";

function FriendProfile() {
  const token = localStorage.getItem("token");
  let myId = "";

  if (token) {
    const decoded = jwtDecode(token);
    myId = decoded.user.id;
  }

  const { id } = useParams();
  const navigate = useNavigate();
  const refClose = useRef(null);

  const [friendDetails, setfriendDetails] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);

  const {
    getUserDetails,
    getUserProfile,
    userDetails,
    unFriend,
    sendRequest,
    acceptRequest,
  } = useContext(UserContext);

  // ---------------- PAGE LOAD ----------------
  useEffect(() => {
    const loadData = async () => {
      try {
        setPageLoading(true);

        const details = await getUserDetails(id);
        setfriendDetails(details);

        // await getUserProfile();
      } catch (err) {
        console.error(err);
      } finally {
        setPageLoading(false);
      }
    };

    loadData();
  }, [id]);

  const onChange = () => {};

  // ---------------- CHECKS ----------------
  const isFriend = (fid) => {
    return userDetails?.friends?.some((f) => f._id === fid);
  };

  const canUnfriend = (friendId) => {
    const hasGets = userDetails?.gets?.some(
      (g) => String(g.from?._id) === String(friendId),
    );

    const hasOwes = userDetails?.owes?.some(
      (o) => String(o.to?._id) === String(friendId),
    );

    return !(hasGets || hasOwes);
  };

  const isRequestSent = () => {
    return friendDetails?.friendRequests?.includes(myId);
  };

  const isIncomingRequest = () => {
    return userDetails?.friendRequests?.some((r) => String(r) === String(id));
  };

  // ---------------- ACTIONS ----------------
  const onClickUnfriend = async () => {
    if (actionLoading) return;

    if (!canUnfriend(id)) {
      alert("Cannot unfriend. Ongoing transactions exist.");
      return;
    }

    try {
      setActionLoading("unfriend");

      await unFriend(id);
      await getUserProfile();

      const updated = await getUserDetails(id);
      setfriendDetails(updated);
    } finally {
      setActionLoading(null);
    }
  };

  const onClickSendRequest = async () => {
    if (actionLoading) return;

    try {
      setActionLoading("send");

      await sendRequest(id);
      await getUserProfile();

      const updated = await getUserDetails(id);
      setfriendDetails(updated);
    } finally {
      setActionLoading(null);
    }
  };

  const onClickAccept = async () => {
    if (actionLoading) return;

    try {
      setActionLoading("accept");

      await acceptRequest(id);
      await getUserProfile();
    } finally {
      setActionLoading(null);
    }
  };

  const modifiedDetail = (detail) => {
    if (!detail) return "";
    detail = String(detail);
    const len = detail.length;

    return (
      detail.slice(0, 2) +
      "*".repeat(Math.max(0, len - 6)) +
      detail.slice(len - 3)
    );
  };

  // ---------------- PAGE LOADER ----------------
  if (pageLoading) {
    return (
      <div className="page-loader">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      {/* ---------------- PROFILE HEADER ---------------- */}
      <div className="d-flex justify-content-center">
        <div className="dp-cont">
          <div>
            <img
              src={
                friendDetails.profilePicture?.url ||
                "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
              }
              className="propic"
              alt="profile"
            />
          </div>

          <div className="proname-cont">
            <h2>{friendDetails.name}</h2>

            <div>
              {isFriend(id) ? (
                <button
                  className="btns"
                  disabled={actionLoading === "unfriend"}
                  onClick={onClickUnfriend}
                >
                  {actionLoading === "unfriend" ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Unfriend"
                  )}
                </button>
              ) : isIncomingRequest() ? (
                <button
                  className="mx-2 btns"
                  disabled={actionLoading === "accept"}
                  onClick={onClickAccept}
                >
                  {actionLoading === "accept" ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Accept"
                  )}
                </button>
              ) : isRequestSent() ? (
                <button className="btns" disabled>
                  Request Sent
                </button>
              ) : (
                <button
                  className="btns"
                  disabled={actionLoading === "send"}
                  onClick={onClickSendRequest}
                >
                  {actionLoading === "send" ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Send Request"
                  )}
                </button>
              )}

              <button
                className="btns ms-md-1"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Friends ({friendDetails?.friends?.length || 0})
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------- DETAILS FORM ---------------- */}
      <div className="profile-wrapper">
        <div className="profile-form">
          <h2 className="form-title">Friend Details</h2>

          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-input disabled-input"
              disabled
              value={friendDetails.name || ""}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Mobile Number</label>
            <input
              type="text"
              className="form-input disabled-input"
              disabled
              value={
                isFriend(id)
                  ? friendDetails.mNumber || ""
                  : modifiedDetail(friendDetails.mNumber)
              }
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="text"
              className="form-input disabled-input"
              disabled
              value={
                isFriend(id)
                  ? friendDetails.email || ""
                  : modifiedDetail(friendDetails.email)
              }
            />
          </div>
        </div>
      </div>

      {/* ---------------- FRIENDS MODAL ---------------- */}
      <div
        className="modal fade friend-profile-modal"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content friend-profile-content">
            {/* Header */}
            <div className="modal-header friend-profile-header">
              <h5 className="modal-title friend-profile-title">
                {friendDetails.name}'s Friends
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body friend-profile-body">
              {friendDetails?.friends?.length === 0 && (
                <div className="friends-empty">No friends found.</div>
              )}

              {friendDetails?.friends?.map((e) => (
                <div
                  key={e._id}
                  className="friend-profile-row"
                  onClick={() => {
                    refClose.current.click();

                    e._id === myId
                      ? navigate("/userProfile")
                      : navigate(`/friendProfile/${e._id}`);
                  }}
                >
                  <img
                    className="friend-profile-avatar"
                    src={
                      e.profilePicture?.url ||
                      "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
                    }
                    alt="profile"
                  />

                  <div className="friend-profile-info">
                    <span className="friend-profile-name">{e.name}</span>
                  </div>

                  <div className="friend-profile-arrow">
                    <i className="fa-solid fa-chevron-right"></i>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="modal-footer friend-profile-footer">
              <button
                type="button"
                className="btn btn-light close-btn"
                data-bs-dismiss="modal"
                ref={refClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FriendProfile;
